<div class="gw-w-full gw-mx-auto">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="gw-space-y-6">
    <div class="gw-space-y-4 gw-p-x-large">
      <p class="gw-text-text-primary gw-text-base">
        {{
          'features.settings.parameters.' + setting.key + '.description'
            | translate
        }}
      </p>

      <ng-container *ngIf="dataUnavailable">
        <p class="gw-text-text-secondary">
          {{
            'features.settings.parameters.globalPaymentSplitRules.unavailable'
              | translate
          }}
        </p>
      </ng-container>

      <ng-container *ngIf="dataLoaded && !dataUnavailable">
        <div formArrayName="rules" class="gw-space-y-4">
          <div
            *ngFor="let rule of rulesArray.controls; let i = index"
            [formGroupName]="i"
            class="gw-flex gw-flex-wrap gw-gap-4 gw-items-end gw-p-4 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1"
          >
            <div class="gw-min-w-[200px] gw-flex-1">
              <gatewee-select-v3
                [items]="pixKeyItems"
                formControlName="pixKeyId"
                [label]="
                  'features.settings.parameters.globalPaymentSplitRules.pixKey'
                    | translate
                "
                [required]="true"
              ></gatewee-select-v3>
            </div>
            <div class="gw-min-w-[120px]">
              <gatewee-input-v2
                [form]="rulesArray.at(i)"
                controlName="value"
                type="number"
                [label]="
                  'features.settings.parameters.globalPaymentSplitRules.value'
                    | translate
                "
                [placeholder]="'0-100'"
              ></gatewee-input-v2>
            </div>
            <div class="gw-min-w-[200px] gw-flex-1">
              <gatewee-select-v3
                [items]="bankAccountItems"
                formControlName="bankAccountId"
                [label]="
                  'features.settings.parameters.globalPaymentSplitRules.bankAccount'
                    | translate
                "
                [required]="true"
              ></gatewee-select-v3>
            </div>
            <div class="gw-min-w-[180px] gw-flex-1">
              <gatewee-input-v2
                [form]="rulesArray.at(i)"
                controlName="description"
                type="text"
                [label]="
                  'features.settings.parameters.globalPaymentSplitRules.descriptionLabel'
                    | translate
                "
              ></gatewee-input-v2>
            </div>
            <gatewee-button
              *ngIf="rulesArray.length > 1"
              variant="outline"
              [title]="'common.actions.remove' | translate"
              (clicked)="removeRule(i)"
              [disabled]="submitting"
            ></gatewee-button>
          </div>
        </div>
        <gatewee-button
          variant="secondary"
          [title]="
            'features.settings.parameters.globalPaymentSplitRules.addRule'
              | translate
          "
          (clicked)="addRule()"
          [disabled]="submitting"
        ></gatewee-button>
      </ng-container>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="
          submitting || (formGroup && formGroup.invalid) || dataUnavailable
        "
      ></gatewee-button>
    </div>
  </form>
</div>
